/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import { useSnackbar } from 'notistack';

import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  Paper,
  Typography,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { imagesAll } from 'src/assets/Images_index';
import Iconify from 'src/components/Iconify';
import Label from 'src/components/Label';
import { SkeletonProjectTab } from 'src/components/skeleton';
import AxiosAll from 'src/services/axiosAll';
import ReportDetail from '../today/reportDetail';
import SideAddTask from './AddTaskSideCard';

export default function UserCard() {
  const theme = useTheme();
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterType, setFilterType] = useState('all'); // 'all', 'watchlist', 'unwatched'
  const [statusFilter, setStatusFilter] = useState('2'); // Add status filter state
  const [statusOptions, setStatusOptions] = useState([]); // Add status options state

  const { userDetails } = useSelector((state) => state.loginReducer);
  const { token } = userDetails;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState('');
  const [userData, setUserData] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [watchlistUsers, setWatchlistUsers] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const getUserWiseData = async (status = null) => {
    setLoading(true);
    const queryParams = status ? `?status=${status}` : '';
    const response = await AxiosAll('get', `/users-tasks${queryParams}`, {}, token);
    const { data } = response;
    window.scrollTo(0, 0);

    if (data?.statusCode === 200) {
      setTableData(data?.data);
      setLoading(false);
    }
  };

  const getWatchlistUsers = async () => {
    try {
      const response = await AxiosAll('get', `/users-watchlist`, {}, token);
      if (response?.data?.statusCode === 200) {
        // Extract user IDs from watchlist
        const watchlistUserIds = response?.data?.data.map((user) => user.id);
        setWatchlistUsers(watchlistUserIds);
      }
    } catch (error) {
      console.error('Error fetching watchlist:', error);
    }
  };

  // Add function to get status options
  const getStatusOptions = async () => {
    try {
      const response = await AxiosAll('get', `/task-statuses`, {}, token);
      if (response?.data?.statusCode === 200) {
        setStatusOptions(response?.data?.data?.data);
      }
    } catch (error) {
      console.error('Error fetching statuses:', error);
    }
  };

  const toggleWatchlist = async (userId) => {
    const isInWatchlist = watchlistUsers?.includes(userId);
    try {
      const endpoint = isInWatchlist
        ? `/users-watchlist/${userId}/remove-from-watchlist`
        : `/users-watchlist/${userId}/add-to-watchlist`;

      const response = await AxiosAll('post', endpoint, {}, token);

      if (response?.data?.status === 'Success') {
        // Update watchlist state based on action
        if (isInWatchlist) {
          setWatchlistUsers((prev) => prev.filter((id) => id !== userId));
        } else {
          setWatchlistUsers((prev) => [...prev, userId]);
        }

        enqueueSnackbar(response?.data?.message, { variant: 'success' });
      }
    } catch (error) {
      console.error('Error updating watchlist:', error);
    }
  };

  // Apply filters and sort data based on watchlist status only
  const applyFilters = () => {
    let result = [...tableData];

    // Filter users based on watchlist status
    if (filterType === 'watchlist') {
      result = result.filter((user) => watchlistUsers.includes(user.id));
    } else if (filterType === 'unwatched') {
      result = result.filter((user) => !watchlistUsers.includes(user.id));
    }

    // If showing all users, sort to prioritize watchlist users
    if (filterType === 'all') {
      result.sort((a, b) => {
        const aInWatchlist = watchlistUsers.includes(a.id) ? 1 : 0;
        const bInWatchlist = watchlistUsers.includes(b.id) ? 1 : 0;
        return bInWatchlist - aInWatchlist; // Watchlist users first
      });
    }

    setFilteredData(result);
  };

  // Handle filter change
  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  // Handle status filter change
  const handleStatusFilterChange = (event) => {
    const newStatusFilter = event.target.value;
    setStatusFilter(newStatusFilter);
    getUserWiseData(newStatusFilter);
  };

  useEffect(() => {
    getUserWiseData();
    getWatchlistUsers();
    getStatusOptions();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [tableData, watchlistUsers, filterType]); // Remove statusFilter from dependencies

  return (
    <div className="task-card-section">
      <ReportDetail idToOpen={id} setOpen={setOpen} open={open} />
      <SideAddTask
        userData={userData}
        setOpen={setSidebarOpen}
        open={sidebarOpen}
        getUserWiseData={() => getUserWiseData(statusFilter)}
      />

      {/* Filter Controls */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Stack direction="row" spacing={2}>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="watchlist-filter-label">Filter Users</InputLabel>
            <Select
              labelId="watchlist-filter-label"
              id="watchlist-filter"
              value={filterType}
              label="Filter Users"
              onChange={handleFilterChange}
            >
              <MenuItem value="all">All Users (Watchlist First)</MenuItem>
              <MenuItem value="watchlist">Watchlist Only</MenuItem>
              <MenuItem value="unwatched">Unwatched Only</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 150 }}>
            <InputLabel id="status-filter-label">Filter by Status</InputLabel>
            <Select
              labelId="status-filter-label"
              id="status-filter"
              value={statusFilter}
              label="Filter by Status"
              onChange={handleStatusFilterChange}
            >
              {statusOptions.map((status) => (
                <MenuItem key={status.id} value={status.id}>
                  {status.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Box>

      {loading ? (
        <>
          {' '}
          <SkeletonProjectTab />
          <SkeletonProjectTab />
          <SkeletonProjectTab />
        </>
      ) : (
        filteredData?.map((item, index) => (
          <Paper variant="outlined" className="task-card" sx={{ p: 2, bgcolor: 'grey.5008' }} key={index}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="h5">{item?.full_name}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar alt={item?.full_name} src={item?.profile_picture || imagesAll.mainWhiteLogo} sx={{ mr: 2 }} />
                <div onClick={() => toggleWatchlist(item?.id)} style={{ marginRight: '10px' }}>
                  <Iconify
                    icon={watchlistUsers.includes(item?.id) ? 'mdi:eye' : 'mdi:eye-off'}
                    sx={{ cursor: 'Pointer' }}
                    style={{ width: '20px', height: '20px' }}
                  />
                </div>
                <div
                  onClick={() => {
                    setUserData(item);
                    setSidebarOpen(true);
                  }}
                >
                  <Iconify
                    icon={'ic:baseline-plus'}
                    sx={{ cursor: 'Pointer' }}
                    style={{ width: '20px', height: '20px' }}
                  />
                </div>
              </Box>
            </Box>

            <Box sx={{ overflowY: 'auto', maxHeight: '420px' }} className="box-height-overflow">
              {/* Tasks Card */}
              {item?.assigned_tasks?.map((cardData, index) => (
                <Card
                  sx={{ p: 1.5, mt: 1, backgroundColor: cardData?.is_due ? 'error.light' : '#fff' }}
                  key={index}
                  onClick={() => {
                    setId(cardData?.id);
                    setOpen(true);
                  }}
                >
                  <Grid container spacing={3}>
                    {/* title and name */}
                    <Grid item xs={10} md={10}>
                      <Typography variant="overline" sx={{ textTransform: 'initial' }}>
                        {cardData?.task_users?.full_name}
                      </Typography>

                      {cardData?.task_priority?.id === 1 && cardData?.task_status?.id !== 5 ? (
                        <div
                          onClick={() => {
                            setId(cardData?.id);
                            setOpen(true);
                          }}
                        >
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={'error'}
                            sx={{
                              textTransform: 'capitalize',
                              height: 'auto',
                              whiteSpace: 'normal',
                              lineHeight: '1.5',
                              cursor: 'pointer',
                            }}
                          >
                            {cardData?.title}
                          </Label>
                        </div>
                      ) : cardData?.is_due ? (
                        <div
                          onClick={() => {
                            setId(cardData?.id);
                            setOpen(true);
                          }}
                        >
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={'primary'}
                            sx={{
                              textTransform: 'capitalize',
                              height: 'auto',
                              whiteSpace: 'normal',
                              lineHeight: '1.5',
                              cursor: 'pointer',
                            }}
                            onClick={() => console.log('from 2', cardData?.id)}
                          >
                            {cardData?.title}
                          </Label>
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            setId(cardData?.id);
                            setOpen(true);
                          }}
                        >
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            sx={{
                              textTransform: 'capitalize',
                              height: 'auto',
                              whiteSpace: 'normal',
                              lineHeight: '1.5',
                              cursor: 'pointer',
                            }}
                            onClick={() => console.log('from 3', cardData?.id)}
                          >
                            {cardData?.title}
                          </Label>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                  {/* Time */}
                  <Box
                    Box
                    sx={{
                      display: 'flex',
                      rowGap: 2,
                      columnGap: 1,
                      gridTemplateColumns: { xs: 'repeat(4, 1fr)', sm: 'repeat(2, 1fr)' },
                    }}
                  >
                    <Typography variant="overline" sx={{ mb: 0.5, textTransform: 'initial' }}>
                      Alloted Time
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {cardData?.planned_time_format}
                    </Typography>
                    <Typography variant="overline" sx={{ mb: 0.5, ml: 1, textTransform: 'initial' }}>
                      Spend Time
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {cardData?.spend_time_format}
                    </Typography>
                  </Box>

                  {/* Dates */}
                  <Box
                    sx={{
                      display: 'flex',
                      rowGap: 2,
                      columnGap: 1,
                      gridTemplateColumns: { xs: 'repeat(4, 1fr)', sm: 'repeat(2, 1fr)' },
                    }}
                  >
                    <Typography variant="overline" sx={{ mb: 0.5, textTransform: 'initial' }}>
                      Start Date
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {moment(cardData?.start_date).format('D MMM YYYY')}
                    </Typography>
                    <Typography variant="overline" sx={{ mb: 0.5, ml: 1, textTransform: 'initial' }}>
                      Due Date
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {moment(cardData?.due_date).format('D MMM YYYY')}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      rowGap: 2,
                      columnGap: 1,
                      gridTemplateColumns: { xs: 'repeat(4, 1fr)', sm: 'repeat(2, 1fr)' },
                    }}
                  >
                    <Typography variant="overline" sx={{ mb: 0.5, textTransform: 'initial' }}>
                      Ticket:
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {cardData?.ticket}
                    </Typography>
                  </Box>

                  {/* Status and priority */}
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      // gridTemplateColumns: { xs: 'repeat(4, 1fr)', sm: 'repeat(2, 1fr)' },
                      // justifyContent: 'space-between',
                      // justifyItems: 'center',
                      // alignItems: 'flex-start',
                      '& > *:first-child': {
                        alignSelf: 'flex-start',
                      },
                      '& > *:last-child': {
                        alignSelf: 'flex-end',
                      },
                    }}
                  >
                    <Label
                      variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                      color={cardData?.task_priority?.color}
                      sx={{
                        textTransform: 'capitalize',
                        borderRadius: '4px',
                        padding: '8px',
                      }}
                    >
                      {cardData?.task_priority?.name}
                    </Label>
                    <Label
                      variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                      color={cardData?.task_status?.color}
                      sx={{
                        textTransform: 'capitalize',
                        borderRadius: '4px',
                        padding: '8px',
                      }}
                    >
                      {cardData?.task_status?.name}
                    </Label>
                  </Box>
                </Card>
              ))}
            </Box>
          </Paper>
        ))
      )}
    </div>
  );
}
